import { Component, OnInit } from '@angular/core';
import { JwtService } from '@app/core/services/jwt.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ApiService } from '@app/core/services/api.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  isLoggedIn: boolean = false;
  constructor(private jwtService: JwtService,
    private authenticationService: AuthenticationService,
    private apiService: ApiService,
    private router: Router,
    private deviceService: DeviceDetectorService) { }
  userName: string;
  dataData: string;
  lastLogin: string;
  messageName: string;

  ngOnInit() {
    const token = this.jwtService.getAuthToken();
    const browser = this.deviceService.browser;
    if (token) {
      this.isLoggedIn = true;
      var loggedInUser = this.jwtService.getLoggedInUser();
      var isLoginSuccess = this.jwtService.isLoginSuccess();
      if (loggedInUser && isLoginSuccess) {
        this.userName = loggedInUser.username;
        if (loggedInUser.lastLoginDate != null) {
          this.lastLogin = loggedInUser.lastLoginDate;
          if (this.lastLogin.indexOf('.') != -1) {
            this.lastLogin = this.lastLogin.split('.')[0].replace('T', ' ');
          }
        }
      } else {
        this.getUser();
      }
      this.getBroadCast();
    }
  }
  getBroadCast() {
    const data = {};
    return this.apiService.get("/broadcast/message").subscribe(
      data => {
        //console.log(data);
        this.messageName = data.data.broadcastMessageVO.message;
        return data;
      });
  }
  getUser() {
    const data = {};
    return this.apiService.post("/login", data).subscribe(
      data => {
        //this.jwtService.saveParticipantId(data.data.wctptUserVO.participantId);
        this.userName = data.data.wctptUserVO.username;
        if (data.data.wctptUserVO.lastLoginDateString != null) {
          this.lastLogin = data.data.wctptUserVO.lastLoginDateString;
          if (this.lastLogin.indexOf('.') != -1) {
            this.lastLogin = this.lastLogin.split('.')[0].replace('T', ' ');
          }
        }
        this.jwtService.setLoginSuccess('true');
        return data;
      }
    );
  }
  logout() {
    this.authenticationService.logout();
    this.jwtService.destroyToken();
    this.jwtService.destroyParticipantId();
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
}
